export const COMMUNITIES = [
  'SC - Madiga','SC - Mala','SC - Others',
  'ST - Lambada','ST - Others',
  'Reddy','Velama','Brahmin','Vaishya','Kshatriya',
  'Kamma','Goud','Munnuru Kapu','Mudiraj','Padmashali',
  'Yadav','Vaddera','Nayi Brahmin','Rajaka',
  'North Indians','OC - Others','BC - Others'
];

export const PROFESSIONS = [
  'Accountant','Advocate / Lawyer','Bank Employee',
  'Business / Self Employed','Doctor / Medical','Driver / Transport',
  'Engineer','Farmer / Agriculture','Government Employee',
  'Graphic Designer','Health Sector / Paramedic','Housewife / Homemaker',
  'Journalist','Labour / Daily Wage','NA','Others / Unknown',
  'Outsourcing Employee','Police / Constable','Private Employee',
  'Professor / Lecturer','Retired Govt Employee','Scientist / Researcher',
  'Security Guards','Social Worker','Software / IT Professional',
  'Student','Private Teacher','Government Teacher','Unemployed / Not Working'
];

export const DISTRICTS = [
  'Hyderabad','Mahabubnagar','Rangareddy','Nalgonda',
  'Medak','Nizamabad','Karimnagar','Warangal','Khammam'
];

export const AGE_GROUPS = [
  {label:'18–25', min:18, max:25},
  {label:'26–40', min:26, max:40},
  {label:'41–60', min:41, max:60},
  {label:'61+',   min:61, max:150},
];

export const GENDER_OPTIONS = [
  {label:'Male',   value:'M'},
  {label:'Female', value:'F'},
  {label:'Other',  value:'O'},
];

export const EDUCATION_LIST = [
  'Below 10th','10th Pass','Inter / 12th','Diploma',
  'Graduate - BA','Graduate - BCom','Graduate - BSc','Graduate - BTech',
  'Post Graduate - MA','Post Graduate - MCom','Post Graduate - MSc','Post Graduate - MTech',
  'MBA','MCA','LLB','MBBS','PhD','Other'
];
